import { ReactNode } from 'react';
import { Box, Button, SxProps, Theme, useTheme } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';

interface MenuButtonProps {
  text?: string;
  startIcon?: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onArrowClick: () => void;
}

const MenuButton = ({
  text,
  startIcon,
  onClick,
  onArrowClick,
}: MenuButtonProps) => {
  const theme = useTheme();

  return (
    <Button
      onClick={onClick ? onClick : onArrowClick}
      variant='contained'
      color='secondary'
      sx={{
        height: '32px',
        borderRadius: '10px',
        backgroundColor: 'primary.main',
        color: theme.palette.primary.contrastText,
        padding: 0,
        paddingLeft: '16px',
        textTransform: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      disableRipple
      disableElevation
    >
      {startIcon && (
        <Box sx={{
          marginRight: '12px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>{startIcon}</Box>
      )}
      {text && text}
      <Box
        onClick={(e) => {
          e.stopPropagation();
          onArrowClick();
        }}
        sx={{
          paddingLeft: '16px',
          paddingRight: '16px',
          marginLeft: '8px',
          borderLeft: `1px solid ${theme.palette.grey[700]}`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CaretDownIcon
          color={theme.palette.primary.contrastText}
          sx={{ width: 10, height: 5 }}
        />
      </Box>
    </Button>
  );
};

const CaretDownIcon = ({ color, sx }: {
  color: string;
  sx: SxProps<Theme>
}) => {
  return (
    <SvgIcon viewBox="0 0 10 5" sx={sx}>
      <path d="M0 0L5 5L10 0H0Z" fill={color} />
    </SvgIcon>
  );
}

export default MenuButton;